import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ScaffoldSidebarService } from '../../framework/sidebar/scaffold-sidebar.service';

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {
  _sidebar;
  item;
  info;
  private _disabled;
  private propertiedDisable: Subject<boolean> = new Subject();
  private propertiesChange: Subject<any> = new Subject();
  private valuesChange: Subject<any> = new Subject();


  constructor(private sidebar: ScaffoldSidebarService) { }
/**
 * Subscription for watch chnages in item currenly set in the properties panel.
 */
  setProperties(item, info?, sidebar?) {
    if (item !== this.item) {
      this._disabled = false;
      this.propertiedDisable.next(this._disabled);
      this.info = info;
      console.log('Setting properties', item);
      this.item = item;
      this.propertiesChange.next(this.item);
      if (this._sidebar) {
        this._sidebar.close();
        this._sidebar = null;
      }
      this._sidebar = sidebar;
    }
  }
  /**
   * Observable for watching a change in the currently selected properties item
   * */
  watchProperties(): Observable<any> {
    return this.propertiesChange.asObservable();
  }

  /**
   *Observable for watching if the properties panel should be disabled
   * */
  propertiesDisabledChange(): Observable<boolean> {
    return this.propertiedDisable.asObservable();
  }

  /**
   * Set the disabled status of the proprties pannel
   * @param disable Status to set
   */
  disableProperties(disable: boolean) {
    this._disabled = disable ? true : false;
    this.propertiedDisable.next(this._disabled);
  }

  /**
   * Subscription for watch changes in the values of the properties panel.
   */
  propertiValueChange(): Observable<any> {
    return this.valuesChange.asObservable();
  }
  /**trigger a changed value event in properties settings*/
  changeValue() {
    this.valuesChange.next('changed value');
  }

}
